module.exports = __webpack_public_path__ + "static/hero-bd3d65d06a6a8624d145ac481ed7aa1c.jpg";